import { render, staticRenderFns } from "./CardAniversariante.vue?vue&type=template&id=6b2f5c02&scoped=true"
import script from "./CardAniversariante.vue?vue&type=script&lang=js"
export * from "./CardAniversariante.vue?vue&type=script&lang=js"
import style0 from "./CardAniversariante.vue?vue&type=style&index=0&id=6b2f5c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2f5c02",
  null
  
)

export default component.exports